import React, { useEffect, useState } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import {format} from 'date-fns'
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export default function LeadTrackingSection(props) {    

    const navigate = useNavigate();

    const apiAttributionUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/get-tracked-data`;

    const hash = sha256(props.searchterm);
	const accessToken = localStorage.getItem("accessToken");

    let getAttributionUrl = `${apiAttributionUrl}?hash=${hash}`;
    
    const [attributionData, setAttributionData] = useState(null);    
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [overLayPopupShow, setOverLayPopupShow] = useState(false);
    const [overLayPopupText, setOverLayPopupText] = useState('');


    const handleOverylayModalShowClose = (modalStatus,modalText) => {
        setOverLayPopupShow(modalStatus);
        setOverLayPopupText(modalText)
    }

    const fetchUrl = (URl) => {        
        
		axios.get(URl, {				
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
			//console.log("result=="+result.data.data.length)
            setIsLoading(false)
            handleOverylayModalShowClose(false,'')
			if(result.data.status === 'success')
			{
				setAttributionData(result.data.data);                
                setError(null);                
			}
			
		})
		.catch((error) => {
			// Error
            handleOverylayModalShowClose(false,'')
            setError(error.message);
            setAttributionData();
			if(error.response.status === 401)
			{
				localStorage.clear();
      			navigate("/login");
			}
		});
	}
   

    useEffect(() => {
        setIsLoading(true);
        handleOverylayModalShowClose(true,'Attribution Data Loading... Please Wait')
		fetchUrl(getAttributionUrl);// eslint-disable-next-line
        setAttributionData()// eslint-disable-next-line
	}, [props.getDate]);
      
    

        return (
            <>
                <div className="app-wrapper">
                <div className="app-content pt-3 p-md-3 p-lg-4">
                    <div className="container-xl">

                        <OverlayLoader 
                            show={overLayPopupShow}
                            title=''
                            body={overLayPopupText}
                        />

                        <div className="app-content pt-3 mb-5">
							{props.searchterm ? (
								<h3>
									Search: <code>{props.searchterm}</code>
								</h3>
							) : (
								<h3>There is no name in the query string</h3>
							)}                
                      	</div>

                        {error && (
                            <div className="w-50 mx-auto alert alert-danger fade show">{`There is a problem fetching the Attribution data - ${error}`}</div>
                        )}
                        
                        <div className="row g-3 mb-4 align-items-center justify-content-between">
                            <div className="col-auto">
                                <h1 className="app-page-title mb-0">Lead Attribution Data</h1>
                            </div>				    
                        </div>

                                                                    
                        
                        
                        <div className="tab-content" id="orders-table-tab-content">
                            <div className="tab-pane fade show active" id="orders-all" role="tabpanel" aria-labelledby="orders-all-tab">
                                <div className="app-card app-card-orders-table shadow-sm mb-5">
                                    <div className="app-card-body">
                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered border-success">
                                                <thead>
                                                    <tr>
                                                        <th>Signup ID</th>
                                                        <th>Offer ID</th>
                                                        <th>Signup Date</th>
                                                        <th>First Signup</th>
                                                        <th>Source</th>
                                                        <th>Campaign</th>
                                                        <th>Content</th>
                                                        <th>Term</th>
                                                        <th>Medium</th>
                                                        <th>Keyword</th>
                                                        <th>Gclid</th>
                                                        <th>Gclsrc</th>
                                                        <th>Dclid</th>
                                                        <th>Fbclid</th>
                                                        <th>Msclkid</th>
                                                        <th>Gbraid</th>
                                                        <th>Wbraid</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
 
                                                {isLoading ? <tr><td colSpan={7}><LoadingSpinner /></td></tr> : ''}

                                                {attributionData && attributionData.map((attriData, i) => {                                                   

                                                    var formattedSignupDate = format(new Date(attriData.signupdate),"MMM dd, y h:mm:ss")
                                                    
                                                        return (
                                                            <tr key={i}>
                                                                <td>{attriData.signup_id}</td>
                                                                <td>{attriData.offerid}</td>
                                                                <td>{formattedSignupDate}</td>
                                                                <td>{attriData.first_signup}</td>
                                                                <td>{attriData.source}</td>
                                                                <td>{attriData.campaign}</td>
                                                                <td>{attriData.content}</td>
                                                                <td>{attriData.term}</td>
                                                                <td>{attriData.medium}</td>
                                                                <td>{attriData.keyword}</td>
                                                                <td>{attriData.gclid}</td>
                                                                <td>{attriData.gclsrc}</td>
                                                                <td>{attriData.dclid}</td>
                                                                <td>{attriData.fbclid}</td>
                                                                <td>{attriData.msclkid}</td>
                                                                <td>{attriData.gbraid}</td>
                                                                <td>{attriData.wbraid}</td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    })

                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    
                                    </div>
                                </div>												
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        )
    }